export const isTestEnv = process.env.REACT_APP_TST_ENV === "true";
